import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BackgroundContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULT_BACKGROUNDS = {
    bridge: 'https://static.prod-images.emergentagent.com/jobs/9645c0b6-481f-4d07-81fb-c2ea43b51b14/images/b3e5202161cf537fb0cf7fbf86c118d612f12ee77c72cd41f3a1d665347845d6.png',
    hangar: 'https://static.prod-images.emergentagent.com/jobs/9645c0b6-481f-4d07-81fb-c2ea43b51b14/images/d30338b369eaa06ed2484a5aab57e44883e9e43ba0bbe8f54ecf63abb4ce73fd.png',
    war_room: 'https://static.prod-images.emergentagent.com/jobs/9645c0b6-481f-4d07-81fb-c2ea43b51b14/images/6e474b3df22e3055f6943190a41366b29565a89e25194d1b6c4b81cc9373a511.png',
    personnel: 'https://static0.polygonimages.com/wordpress/wp-content/uploads/chorus/uploads/chorus_asset/file/13719978/Screenshot_2019_01_28_12.14.51.png?w=1600&h=900&fit=crop',
    operations: 'https://images.unsplash.com/photo-1762441112136-4dfc6edf58e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxzcGFjZXNoaXAlMjBiYXR0bGUlMjBmbGVldCUyMGNvbWJhdCUyMHNjaS1maXxlbnwwfHx8fDE3NzQ1MzM2Mzd8MA&ixlib=rb-4.1.0&q=85',
    announcements: 'https://images.unsplash.com/photo-1760813360432-9b5d79eb9679?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxzcGFjZSUyMHN0YXRpb24lMjBjb21tYW5kJTIwY2VudGVyJTIwc2NpLWZpfGVufDB8fHx8MTc3NDUzMzYzNnww&ixlib=rb-4.1.0&q=85',
    mission_strike: 'https://static.prod-images.emergentagent.com/jobs/9645c0b6-481f-4d07-81fb-c2ea43b51b14/images/e95c7ff7ad6bd161cbb58b55c1f26e2c2be399dbba3c28a4bbde6ab6465bfebe.png',
    mission_escort: '',
    mission_recon: ''
};

export const BackgroundProvider = ({ children }) => {
    const [backgrounds, setBackgrounds] = useState(DEFAULT_BACKGROUNDS);

    useEffect(() => {
        fetchBackgrounds();
    }, []);

    const fetchBackgrounds = async () => {
        try {
            const response = await axios.get(`${API}/backgrounds`);
            const data = response.data;
            setBackgrounds({
                bridge: data.bridge || DEFAULT_BACKGROUNDS.bridge,
                hangar: data.hangar || DEFAULT_BACKGROUNDS.hangar,
                war_room: data.war_room || DEFAULT_BACKGROUNDS.war_room,
                personnel: data.personnel || DEFAULT_BACKGROUNDS.personnel,
                operations: data.operations || DEFAULT_BACKGROUNDS.operations,
                announcements: data.announcements || DEFAULT_BACKGROUNDS.announcements,
                mission_strike: data.mission_strike || DEFAULT_BACKGROUNDS.mission_strike,
                mission_escort: data.mission_escort || DEFAULT_BACKGROUNDS.mission_escort,
                mission_recon: data.mission_recon || DEFAULT_BACKGROUNDS.mission_recon,
            });
        } catch (error) {
            console.error('Failed to fetch backgrounds:', error);
        }
    };

    const getBackground = (page) => {
        return backgrounds[page] || DEFAULT_BACKGROUNDS[page] || '';
    };

    return (
        <BackgroundContext.Provider value={{ backgrounds, getBackground, refreshBackgrounds: fetchBackgrounds }}>
            {children}
        </BackgroundContext.Provider>
    );
};

export const useBackgrounds = () => {
    const context = useContext(BackgroundContext);
    if (!context) {
        throw new Error('useBackgrounds must be used within a BackgroundProvider');
    }
    return context;
};
